// getSettingsData.js
'use strict';
import { Collection } from 'immutable';
import createCachedSelector from '../resource/createCachedSelector.js';

/**
 * Select settings data by data key
 * @kind selector
 * @param {Immutable.Map} state - root state.
 * @param {string} dataKey - settings key.
 * @return {any} The selected settings data.
 */
const getSettingsData = createCachedSelector(
  state => state.getIn(['me', 'settings']),
  (state, dataKey) => dataKey,
  (settings, dataKey) => {
    let result = undefined;
    if (settings) {
      result = settings.get(dataKey);
    }
    return result instanceof Collection ? result.toJS() : result;
  }
)((state, dataKey) => dataKey);

export default getSettingsData;
